import { object, string } from 'yup'

import { errorMessages } from 'translations'

export const validateCardholderSchema = object({
  cardholderId: string().required(errorMessages.fieldRequired),
})
